import {
  Auth,
  UserCredential,
  createUserWithEmailAndPassword as firebaseCreateUserWithEmailAndPassword,
  signInWithEmailAndPassword as firebaseSignInWithEmailAndPassword,
} from 'firebase/auth';

import { auth } from '@helpers/firebase/Initialize';

export async function createUserWithEmailAndPassword(username: string, password: string) {
  return await persistentEmailAndPasswordAuthRequest(
    auth,
    firebaseCreateUserWithEmailAndPassword,
    username,
    password
  );
}

export async function signInWithEmailAndPassword(username: string, password: string) {
  return await persistentEmailAndPasswordAuthRequest(
    auth,
    firebaseSignInWithEmailAndPassword,
    username,
    password
  );
}

async function persistentEmailAndPasswordAuthRequest(
  auth: Auth,
  authFunction: (auth: Auth, username: string, password: string) => Promise<UserCredential>,
  username: string,
  password: string
): Promise<UserCredential> {
  const userCredential: UserCredential = await authFunction(auth, username, password);
  return userCredential;
}

export function validateUserPassword(password: string) {
  if (!password) return "Password can't be empty.";
  if (password.length < 6) return 'Password must contain at least 6 characters.';
  return '';
}

export function validateUserEmail(email: string) {
  const re = /\S+@\S+\.\S+/;
  if (!email) return "Email can't be empty.";
  if (!re.test(email)) return 'Please enter a valid email address.';
  return '';
}
